module.exports = "/0e8d9e4c10ecc96ae93aaa2b69d940f1c8363bc3/e9049f5e7574edf1dbc63410dd94e9e9.svg";